<div>
    <cc-game-iframe-launcher
        *ngIf="loadIframe"
        [gameId]="thunderbiteGameId"
        [thunderBiteIframeHeight]="thunderBiteIframeHeight"></cc-game-iframe-launcher>
</div>
